import React, { Component } from 'react';

// import Custom Componenets
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import API_URL, { Post, Delete, Get, JENIS_DESA, } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import axios from 'axios';
import Datetime from 'react-datetime';

import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import ReactSelect from 'react-select';
import NumberFormat from 'react-number-format';
import { numberSeparator } from '../../../function/Format';

let DefaultIcon = L.icon({
	iconSize: [25, 41],
	iconAnchor: [10, 41],
	iconUrl: icon,
	shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const frmDex = {
	uuid: '',
	tanggal: new Date(),
	pajak: '',
	retribusi: '',
	penerimaan_lainnya: '',
	pemotongan: '',
	penyetoran: '',
	saldo: '',
}

const dateFormat = require('dateformat');

class MenuC5 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			loading: false,
			loadingPreview: false,
			imagePreview: null,
			cetakPreview: false,
			detailPreview: false,
			detailData: null,
			awal: '',
			sebelum: '',
			hal: [],
			setelah: '',
			akhir: '',
			dt: frmDex,
			judul: 'Tambah Kas Pembantu ' + JENIS_DESA,
			textCari: '',
			listTahun: [],
			// tahunCetak: new Date().getFullYear(),
			tahunCetak: null,
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			editMode: false
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	pagination = data => {
		// const data = this.state.pagination;
		//console.log(data);
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = "primary-custom";
				if (i === data.current_page) {
					warna = "danger";
				}
				hal.push(
					<a
						onClick={() => this.fetch({ page: i })}
						className={
							"btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
						}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelum = (
					<a
						onClick={() => this.fetch({ page: p })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{"<"}
					</a>
				);
			}
			if (n > 0) {
				setelah = (
					<a
						onClick={() => this.fetch({ page: n })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{">"}
					</a>
				);
			}
			awal = (
				<a
					onClick={() => this.fetch({ page: 1 })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{"<<"}
				</a>
			);
			akhir = (
				<a
					onClick={() => this.fetch({ page: data.last_page })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{">>"}
				</a>
			);
		}
		this.setState({ awal, sebelum, hal, setelah, akhir });
	};

	fetch = (params = {}) => {
		this.setState({ loading: true })
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
					link =
						"?page=" +
						Math.ceil(
							this.state.pagination.total / this.state.pagination.per_page
						);
					break;
				case ">":
					link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
					break;
				case "<":
					link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
					break;
				case "<<":
					link = "?page=1";
					break;
				default:
					link = "?page=" + params.page;
					break;
			}
		}

		Post("buku-kas-pembantu" + link, null, {
			q: this.state.textCari
		}, dtkat => {
			if (dtkat.data.results) {
				console.log('masuk');
				this.setState({
					data: dtkat.data.results.data,
					pagination: dtkat.data.results,
					loading: false
				})
				this.pagination(dtkat.data.results);
			}

		});

	};

	handleCetak = ((e) => {
		e.preventDefault()

		if (this.state.tahunCetak) {
			this.setState({ loading: false, cetakPreview: false })
			this.downloadSurat()
		} else {
			const alertData = {
				show: true,
				basicType: "info",
				basicTitle: "Data Belum Lengkap",
				pesanAlert: "Mohon isi seluruh data dengan benar"
			}
			this.setState(alertData)
		}
	})

	// ================== simpan data ==================
	simpan = ((e) => {
		e.preventDefault();

		this.setState({ loadingPreview: true })

		let bodyData = this.state.dt
		console.log(bodyData);
		bodyData = {
			...bodyData,
			tanggal: dateFormat(bodyData.tanggal, "yyyy-mm-dd"),
			pemotongan: document.getElementById('pemotongan').value.replace(/[^\d]/g, ''),
			penyetoran: document.getElementById('penyetoran').value.replace(/[^\d]/g, ''),
			saldo: document.getElementById('saldo').value.replace(/[^\d]/g, ''),
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyData.uuid === "" || bodyData.uuid == null) {
			psn = "tambah";
			resstat = 201;
			bodyData.uuid = null;
		} else {
			psn = "ubah";
			resstat = 200;
			metode = "update";
		}

		console.log(bodyData);

		Post('buku-kas-pembantu/' + metode, bodyData.uuid, bodyData, res => {
			// console.log(res);
			if (res.status === resstat) {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "success",
					basicTitle: "Data Kas Pembantu " + JENIS_DESA,
					pesanAlert: "Berhasil " + psn + " Data"
				});

				document.getElementById('form-data').reset()
				// this.fetch();
				this.componentDidMount();
				this.setState({
					dt: frmDex,
					status: {
						...this.state.status,
						form: false
					}
				})
			} else {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "danger",
					basicTitle: "Data Kas Pembantu " + JENIS_DESA,
					pesanAlert: "Gagal " + psn + " Data"
				});
			}
		})

	});
	// ========================================================================

	bukaForm = () => {
		this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
	};

	tutupForm = () => {
		this.setState({
			formDisposisi: false,
			status: {
				...this.state.status,
				form: false,
			},
		})

		this.forceUpdate();
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data Kas Pembantu " + JENIS_DESA,
			editMode: true
		})

		if (data) {
			console.log(data);
			this.setState({
				tmpImages: [],
				dt: {
					...this.state.dt,
					uuid: data.uuid,
					tanggal: new Date(data.tanggal),
					pajak: data.pajak,
					retribusi: data.retribusi,
					penerimaan_lainnya: data.penerimaan_lainnya,
					pemotongan: data.pemotongan,
					penyetoran: data.penyetoran,
					saldo: data.saldo,
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
	}

	cariData = (e) => {
		if (e.key === 'Enter') {
			let txt = e.target.value
			this.setState({
				textCari: txt.trim(),
				loading: true
			});
			setTimeout(
				function () {
					this.fetch();
				}.bind(this),
				500
			);
		}
	};

	downloadSurat = () => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";

		fetch(API_URL + 'buku-kas-pembantu/cetak?tahun=' + this.state.tahunCetak.value, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
			// .then((response) => response.blob())
			.then((response) => {
				if (response.status == 200) {
					return response.blob()
				}
				this.setState({
					loading: false,
					show: true,
					basicType: 'danger',
					basicTitle: 'Data Kas Pembantu ' + JENIS_DESA,
					pesanAlert: 'Gagal cetak surat'
				});
				throw new Error('Something went wrong');
			})
			.then((blob) => {
				// Create blob link to download
				const url = window.URL.createObjectURL(
					new Blob([blob]),
				);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute(
					'download',
					`Kas Pembantu ${JENIS_DESA} ${this.state.tahunCetak.value}.pdf`,
				);

				// Append to html link element page
				document.body.appendChild(link);

				// Start download
				link.click();

				// Clean up and remove the link
				link.parentNode.removeChild(link);
				this.setState({
					loading: false,
				})
			})
			.catch((e) => {
				// console.log(e);
			})
			;
	}

	changeSelectValue = (e, sel) => {
		this.setState({
			[sel]: e
		})
	}

	componentDidMount() {
		this.fetch()
		Get("buku-kas-pembantu/list-tahun", null, dtkat => {
			let listTahun = []
			if (dtkat.results && dtkat.results.length > 0) {
				dtkat.results.map((e) => {
					listTahun.push({ value: e, label: e })
				})
			}
			this.setState({
				listTahun
			})
		});
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
			{
				dataField: 'tanggal',
				text: 'TANGGAL',
				headerAlign: 'center',
				align: 'center',
				sort: false,
			},
			// {
			// 	dataField: 'tentang',
			// 	text: 'JUDUL',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'retribusi',
			// 	text: 'retribusi SINGKAT',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'pemotongan',
				text: 'PEMOTONGAN',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: function (cell, row) {
					return "Rp. " + numberSeparator(row.pemotongan);
				}
			},
			{
				dataField: 'penyetoran',
				text: 'PENYETORAN',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: function (cell, row) {
					return "Rp. " + numberSeparator(row.penyetoran);
				}
			},
			// {
			// 	dataField: 'jumlah_penyetoran_komulatif',
			// 	text: 'JUMLAH penyetoran KUMULATIF',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'saldo',
				text: 'SALDO',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: function (cell, row) {
					return "Rp. " + numberSeparator(row.saldo);
				}
			},
			// {
			// 	dataField: 'nomor_tanggal_dilaporkan',
			// 	text: 'NOMOR DAN TANGGAL DILAPORKAN',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false,
			// 	formatter: (cell, row) => {
			// 		if (row) {
			// 			return `${row.penerimaan_lainnya} / ${row.tanggal_dilaporkan}`
			// 		}
			// 		return '';
			// 	}
			// },
			// {
			// 	dataField: 'keterangan',
			// 	text: 'KET.',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				formatter: function (cell, row) {
					return (
						<div style={{ minWidth: "61px" }}>
							<Button
								size="xs"
								color="success"
								className="btn-icon mr-2"
								onClick={() => this.ubahData(row)}
							// disabled={btnAksi}
							>
								<i className="fa fa-pencil"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="info"
								className="btn-icon mr-2"
								onClick={() => {
									this.setState({
										detailPreview: true,
										detailData: row
									})
								}}
							>
								<i className="fa fa-eye"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="danger"
								className="btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlert
												showCancel
												confirmBtnText="Hapus"
												confirmBtnBsStyle="danger"
												cancelBtnBsStyle="success"
												type="danger"
												title="Yakin ingin hapus data ?"
												onCancel={this.hideAlert}
												onConfirm={() => {
													Delete('buku-kas-pembantu/delete', row.uuid, (res) => {
														if (res === 200) {
															this.setState({
																show: true,
																basicType: 'success',
																basicTitle: 'Data Kas Pembantu ' + JENIS_DESA,
																pesanAlert: 'Berhasil hapus data'
															});
															// this.fetch()
															this.componentDidMount();
														} else {
															this.setState({
																show: true,
																basicType: 'danger',
																basicTitle: 'Data Kas Pembantu ' + JENIS_DESA,
																pesanAlert: 'Gagal hapus data'
															});
														}
														this.setState({ alert: null })
													})
												}}
											>
												Proses ini tidak dapat dibatalkan!
											</SweetAlert>
										)
									});
								}}
								disabled={this.state.status.btnAksi}
							>
								<i className="fa fa-trash"></i>
							</Button>
						</div>
					)
				}.bind(this)
			}
		]

		return (
			<div>
				{/* <Breadcrumb title="Data Kas Pembantu Desa" parent="Admin" /> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				<SweetAlert
					show={this.state.loadingPreview}
					showCancel={false}
					showConfirm={false}
				>
					<div align="center">
						{/* <h5 className="modal-title mb-3" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5> */}
						<img
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")}
							style={{
								borderRadius: "10px",
								width: '150px'
							}}
						/>
					</div>
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-header">
									<div className="row">
										<div className="col-sm-6 text-left">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="info"
												className="btn-icon mr-2"
												onClick={() => {
													this.setState({ cetakPreview: true })
													// this.downloadSurat()
												}}
											>
												Cetak
											</Button>{" "}
											<Button
												size="sm"
												color="success"
												className="btn-square"
												onClick={() => {
													this.setState({
														judul: 'Tambah Kas Pembantu ' + JENIS_DESA,
														dt: frmDex,
														tmpImages: ['kosong'],
														editMode: false,
														currentLocation: this.state.curStaticLocation
													});
													// document.getElementById('form-data').reset()
													this.bukaForm();
												}}
											>
												Tambah Data
											</Button>
										</div>
									</div>
								</div>

								<div className="card-body datatable-react custom-font-sm">
									{/* <div className="row">
										<div className="col-md-12"> */}
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../../../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<div className='row'>
											<div className="col-md-5 text-right">
												<input
													type="text"
													className="form-control"
													style={{ marginBottom: '15px' }}
													id="cariTable"
													placeholder={"Cari berdasarkan tanggal"}
													defaultValue={this.state.textCari}
													onChange={(e) => {
														this.setState({ textCari: e.target.value })
													}}
													onKeyPress={this.cariData}
												/>
												<div className="clearBtnSearch" style={{ display: this.state.textCari !== '' ? 'inline' : '' }}>
													<span className='fa fa-close' style={{ fontSize: '1.3em', cursor: 'pointer' }} onClick={() => {
														this.setState({
															textCari: '',
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
														document.getElementById('cariTable').value = ''
													}} ></span>
												</div>
											</div>
											<div className="col-md-7" style={{ marginBottom: '15px' }}>
												<Button
													size="sm"
													color="info"
													className="btn-square"
													onClick={() => {
														this.setState({
															textCari: document.getElementById("cariTable").value,
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
													}}
												>
													<i className="fa fa-search"></i>
												</Button>
											</div>
											{data.length > 0 ? (
												<>
													<div className="col-md-12">
														<BootstrapTable
															keyField="id"
															data={data}
															columns={columns}
														/>
														<div className="pull-right text-white">
															{this.state.awal}
															{this.state.sebelum}
															{this.state.hal.map(dt => {
																return dt;
															})}
															{this.state.setelah}
															{this.state.akhir}
														</div>
													</div>
												</>
											) : (
												<div className="col-md-12">
													<h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
												</div>
											)}
										</div>
									)}
									{/* </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<Modal
					open={this.state.cetakPreview ? true : false}
					onClose={() => {
						this.setState({ cetakPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '40%', maxWidth: 'unset' } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.handleCetak(e) }}>
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Cetak Data Kas Umum</h5>
						</div>
						<div className="modal-body">
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tahun</Label>
									<ReactSelect
										classNamePrefix="select"
										onChange={e => {
											this.changeSelectValue(e, "tahunCetak")
										}}
										defaultValue={this.state.tahunCetak}
										value={this.state.tahunCetak}
										name="nik"
										options={this.state.listTahun}
										placeholder="Pilih Tahun"
										// isClearable
									/>
									{/* <input
										className="form-control"
										id="tahun"
										type="number"
										min={2010}
										placeholder="Masukkan tahun"
										defaultValue={this.state.tahunCetak}
										onChange={(e) => {
											this.setState({
												tahunCetak: e.target.value
											})
										}}
										required
									/> */}
								</Col>
							</div>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								onClick={() => {
									this.setState({ cetakPreview: false })
								}}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success">
								Cetak
							</button>
						</div>
					</Form>
				</Modal>
				<Modal
					open={this.state.detailPreview ? true : false}
					onClose={() => {
						this.setState({ detailPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
				>
					<div className="modal-header">
						<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Detail Data Kas Pembantu</h5>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-md-12">
								{this.state.detailData ? (
									<>
										<div className="table-responsive">
											<table className='detail-dokumen-administrasi'>
												<tbody>
													<tr>
														<th width="280">Tanggal</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tanggal}</span></td>
													</tr>
													<tr>
														<th width="280">Pajak</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.pajak}</span></td>
													</tr>
													<tr>
														<th width="280">Retribusi</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.retribusi}</span></td>
													</tr>
													<tr>
														<th width="280">Penerimaan Lainnya</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.penerimaan_lainnya}</span></td>
													</tr>
													<tr>
														<th width="280">Pemotongan</th>
														<th width="50" className="text-center">:</th>
														<td><span>Rp. {numberSeparator(this.state.detailData.pemotongan)}</span></td>
													</tr>
													<tr>
														<th width="280">Penyetoran</th>
														<th width="50" className="text-center">:</th>
														<td><span>Rp. {numberSeparator(this.state.detailData.penyetoran)}</span></td>
													</tr>
													<tr>
														<th width="280">Saldo</th>
														<th width="50" className="text-center">:</th>
														<td><span>Rp. {numberSeparator(this.state.detailData.saldo)}</span></td>
													</tr>
												</tbody>
											</table>
										</div>
									</>
								) : ''}
							</div>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.status.form}
					onClose={this.tutupForm}
					closeOnEsc={false}
					closeOnOverlayClick={false}
					styles={{ modal: { width: '60%', maxWidth: "unset" } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.simpan(e) }}>
						<input className="form-control" id="uuid" type="hidden" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid} />
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							{/* <input
								className="form-control"
								id="uuid"
								type="hidden"
								placeholder="UUID"
								defaultValue={this.state.dt.uuid}
								value={this.state.dt.uuid}
							/> */}

							<div className="form-row">
								<Col sm="12">
									<Label htmlFor="validationCustom05">Tanggal penerimaan / pengeluaran</Label>
									<Datetime
										inputProps={{
											"data-testid": "tanggal",
											placeholder: 'Tanggal pemotongan / penyetoran',
											required: true
										}}
										inputId="tanggal"
										name="tanggal"
										locale="id-ID"
										timeFormat={false}
										dateFormat="DD/MM/yyyy"
										closeOnTab={true}
										closeOnSelect={true}
										initialValue={this.state.dt.tanggal}
										value={this.state.dt.tanggal}
										onChange={e => {
											if (typeof e._isValid !== 'undefined') {
												let tgl = e.format('YYYY-MM-DD');
												this.setState({
													dt: {
														...this.state.dt,
														tanggal: new Date(tgl)
													}
												})
											}
										}}
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Uraian Penerimaan Pajak, Retribusi, dan Penerimaan Lainnya</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Pajak</Label>
									<textarea className='form-control' name="pajak" id="pajak" cols="30" placeholder={`Uraian penerimaan pajak`} defaultValue={this.state.dt.pajak} onChange={(e) => {
										this.setState({
											dt: {
												...this.state.dt,
												pajak: e.target.value
											}
										})
									}} rows="4" required />
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Retribusi</Label>
									<textarea className='form-control' name="retribusi" id="retribusi" cols="30" placeholder={`Uraian penerimaan retribusi`} defaultValue={this.state.dt.retribusi} onChange={(e) => {
										this.setState({
											dt: {
												...this.state.dt,
												retribusi: e.target.value
											}
										})
									}} rows="4" required />
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Penerimaan Lainnya</Label>
									<textarea className='form-control' name="penerimaan_lainnya" id="penerimaan_lainnya" cols="30" placeholder={`Uraian penerimaan lainnya`} defaultValue={this.state.dt.penerimaan_lainnya} onChange={(e) => {
										this.setState({
											dt: {
												...this.state.dt,
												penerimaan_lainnya: e.target.value
											}
										})
									}} rows="4" required />
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Nominal Pemotongan & Penyetoran (Rp.)</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Pemotongan</Label>
									<NumberFormat
										data-testid="pemotongan"
										id="pemotongan"
										name="pemotongan"
										placeholder="Masukkan nominal pemotongan. Contoh : 1.500.000"
										thousandSeparator={true}
										prefix={'Rp. '}
										className="form-control"
										defaultValue={this.state.dt.pemotongan}
										value={this.state.dt.pemotongan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													pemotongan: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Penyetoran</Label>
									<NumberFormat
										data-testid="penyetoran"
										id="penyetoran"
										name="penyetoran"
										placeholder="Masukkan nominal penyetoran. Contoh : 1.500.000"
										thousandSeparator={true}
										prefix={'Rp. '}
										className="form-control"
										defaultValue={this.state.dt.penyetoran}
										value={this.state.dt.penyetoran}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													penyetoran: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Saldo Kas (Rp.)</Label>
									<NumberFormat
										data-testid="saldo"
										id="saldo"
										name="saldo"
										placeholder="Masukkan nominal saldo kas. Contoh : 15.000.000"
										thousandSeparator={true}
										prefix={'Rp. '}
										className="form-control"
										defaultValue={this.state.dt.saldo}
										value={this.state.dt.saldo}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													saldo: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								disabled={this.state.status.btnForm}
								onClick={this.tutupForm}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>
								Simpan
							</button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

export default MenuC5;
